import { Fragment, useState } from "react";
import { Link } from "react-router-dom";
import { Nav, NavItem, NavLink } from "reactstrap";
import { SocialTabLists } from "../../../../data/applications/SocialApp";
import { SocialAppProp } from "../../../../types/Applications";
import { routes } from "../../../../routers/routes";

const SocialTabs: React.FC<SocialAppProp> = ({ callback }) => {

  const [activeTab, setActiveTab] = useState(1);
  const tabHandler = (id: number) => {
    setActiveTab(id);
    callback(id);
  };

  return (
    <Nav tabs className="border-tab tabs-scoial">
      {SocialTabLists.map((data, index) => (
        <Fragment key={index}>
          {data.userProfile ? (
            <NavItem>
              <div className="user-designation" />
              <div className="title">
                <Link to={routes.Social}>ElANA</Link>
              </div>
              <div className="desc mt-2">general manager</div>
            </NavItem>
          ) : (
            <NavItem className="nav">
              <NavLink className={activeTab === data.id ? "active" : ""} onClick={() => tabHandler(data.id)}>
                {data.tittle}
              </NavLink>
            </NavItem>
          )}
        </Fragment>
      ))}
    </Nav>
  );
};
export default SocialTabs;